<template>
  <!-- Account is loading view. If we don't have their account, we don't know their bidding status -->
  <transition
    v-if="isLoadingAccount"
    name="fade"
    mode="out-in"
  >
    <div class="textCenter w-100 marginSmallTop">
      <i class="fa fa-spinner fa-spin fa-1x fa-fw" />
      <span class="sr-only">Loading...</span>
    </div>
  </transition>
  <!-- SINGLE ITEM view -->
  <transition
    v-else-if="view_type === 'item'"
    :name="'bidding-status-update'"
  >
    <div
      v-if="!isPreviewMode"
      :key="itemBiddingMessage.message"
      class="paddingSmallTop paddingSmallBottom paddingNormalLeft"
      :class="{ 
        flagColorSuccess: itemBiddingMessage.severity === 'success', 
        flagColorError: itemBiddingMessage.severity === 'error', 
        flagColorDefault: itemBiddingMessage.severity === 'default' 
      }"
      v-html="itemBiddingMessage.message"
    />
  </transition>

  <!-- LIST view (condensed or regular) -->
  <div v-else>
    <transition :name="'bidding-status-update'">
      <div
        :key="itemBiddingMessage.message"
        class="paddingSmallTop paddingSmallRight paddingSmallBottom"
        :class="{ 
          colorSuccess: itemBiddingMessage.severity === 'success', 
          colorError: itemBiddingMessage.severity === 'error', 
          colorDefault: itemBiddingMessage.severity === 'default' 
        }"
        v-html="itemBiddingMessage.message"
      />
    </transition>
    <transition
      name="fade"
      mode="out-in"
    >
      <div v-html="itemSoldStatus" />
    </transition>
  </div>
</template>

<script>

export default {
	name: 'BiddingStatus',
	props: [
		'item_id',
		'view_type'
	],
	computed: {
		itemBiddingMessage: function () {
			return this.$store.getters.itemBiddingMessage(this.item_id, this.view_type)
		},
		itemBiddingStatus: function () {
			return this.$store.getters.itemBiddingStatus(this.item_id)
		},
		itemHasTelephoneBid: function () {
			return this.$store.getters.itemHasTelephoneBid(this.item_id)
		},
		isAuthenticated: function () {
			return this.$store.getters.isAuthenticated
		},
		itemSoldStatus: function () {
			return this.$store.getters.itemSoldStatus(this.item_id)
		},
		isPreviewMode: function () {
			return this.$store.getters.isPreviewMode(this.item_id)
		},
        isLoadingAccount: function () {
            return this.$store.getters.isLoadingAccount
        }
		
	}
}
</script>

<style scoped>
</style>
